export type NavigationDirection = "next" | "previous";

export function getAdjacentId<TId extends string>(
  orderedIds: readonly TId[],
  currentId: TId | null,
  direction: NavigationDirection
): TId | null {
  if (orderedIds.length === 0) {
    return null;
  }

  const currentIndex = currentId === null ? -1 : orderedIds.indexOf(currentId);

  if (currentIndex === -1) {
    const startIndex = direction === "next" ? 0 : orderedIds.length - 1;
    return orderedIds[startIndex] ?? null;
  }

  const offset = direction === "next" ? 1 : -1;
  const nextIndex = (currentIndex + offset + orderedIds.length) % orderedIds.length;

  return orderedIds[nextIndex] ?? null;
}
